module.exports = __webpack_public_path__ + "static/media/small_hublot.c5bb94be.png";